import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { RemoveBooking} from '../../types/Types';


export const useRemoveBooking = (
  options?: UseMutationOptions<RemoveBooking, unknown, RemoveBooking, unknown>
) => {
  return useMutation({
    ...options,
    mutationFn: (data: RemoveBooking) =>
      axiosInstance
        .post(getAPIURL(`/Event/RemoveEventAttendee?eventId=${data.eventId}&userId=${data.userId}`), data)
        .then((res) => res.data),
  });
};